import React, { useState } from 'react';
import { SalvButton, SalvCheckbox, SalvIconButton, Size } from '@salvapp/ui-components';
import { alertRfiConfig } from '../apis';
import { faPenToSquare } from '@fortawesome/pro-solid-svg-icons/faPenToSquare';
import { InternalApiAlertRfi } from '../api-internal';

interface Props {
  rfi: InternalApiAlertRfi;
  reloadRfiData: () => void;
}

export const RFIConfiguration = ({ rfi, reloadRfiData }: Props) => {
  const [isAlertRfiConfigEditing, setAlertRfiConfigEditing] = useState(false);
  const [isReScreeningEnabled, setIsReScreeningEnabled] = useState(rfi.isReScreeningEnabled);

  return (
    <div onClick={(event) => event.stopPropagation()} style={{ display: 'flex', alignItems: 'center' }}>
      <SalvCheckbox
        label={'Re-screen automatically after response'}
        disabled={!isAlertRfiConfigEditing}
        selected={isReScreeningEnabled}
        onChange={(isChecked) => setIsReScreeningEnabled(isChecked)}
      />
      {isAlertRfiConfigEditing ? (
        <SalvButton
          label={'Confirm'}
          size={Size.EXTRA_SMALL}
          variant={'secondary'}
          onClick={async () => {
            const hasDataChanged = rfi.isReScreeningEnabled !== isReScreeningEnabled;
            if (hasDataChanged) {
              await alertRfiConfig.updateAlertRfiConfig({
                alertRfiId: rfi.id,
                internalApiAlertRfiConfig: { isAlertReScreeningEnabled: isReScreeningEnabled },
              });
              reloadRfiData();
            }
            setAlertRfiConfigEditing(false);
          }}
        />
      ) : (
        <SalvIconButton
          icon={faPenToSquare}
          ariaLabel={'Edit Alert RFI Config'}
          onClick={() => setAlertRfiConfigEditing(true)}
        />
      )}
    </div>
  );
};
